import React, { useState } from 'react';
import './BrandsModelsManager.css';

const ModalCadastroMarca = ({ isOpen, onClose, onSave }) => {
  const [marca, setMarca] = useState('');

  const handleSubmit = () => {
    if (!marca.trim()) return;
    onSave(marca.trim());
    setMarca('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="bm-modal-overlay">

      <div className="bm-modal">

        <div className="bm-modal-header">
          <h2>Nova Marca</h2>
          <p>Cadastre uma nova marca no sistema</p>
        </div>

        <div className="bm-form">

          <input
            type="text"
            placeholder="Nome da Marca"
            value={marca}
            onChange={(e) => setMarca(e.target.value)}
          />

        </div>

        <div className="bm-modal-actions">

          <button
            className="bm-cancel-btn"
            onClick={onClose}
          >
            Cancelar
          </button>

          <button
            className="bm-save-btn"
            onClick={handleSubmit}
          >
            Salvar
          </button>

        </div>

      </div>
    </div>
  );
};

export default ModalCadastroMarca;
